import { Component, EventEmitter, Output } from "@angular/core"
import { Auth0WrapperService, getCookie } from "@auth/bp-pf-auth";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SupportComponent } from "@support/bp-pf-support";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [SupportComponent],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class HeaderComponent {
  userName: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';

  appId: string = environment.app_id;
  isPanelOpen = false;
  @Output() loadingChange = new EventEmitter<boolean>();

  constructor(private auth0: Auth0WrapperService) { }
  ngOnInit(): void {
    this.getUser();
  }

  public logout() {
    this.loadingChange.emit(true);
    this.auth0.logoutWithRedirect()
  }

  getUser() {
    const getTenantCodeFromCookie = getCookie(`${environment.app_id}_tenant_code`);
    const email = getCookie(`${getTenantCodeFromCookie}_${environment.app_id}_email`);

    if (email) {
      // full email
      this.email = email;

      // part before @
      const [namePart] = email.split('@'); // "john.doe"

      // split into first and last names
      const [first, last] = namePart.split('.');

      this.firstName = first ? first.charAt(0).toUpperCase() + first.slice(1) : '';
      this.lastName = last ? last.charAt(0).toUpperCase() + last.slice(1) : '';

      // for display userName (optional)
      this.userName = `${this.firstName} ${this.lastName}`.trim();
    } else {
      this.firstName = 'Guest';
      this.lastName = '';
      this.email = '';
      this.userName = 'Guest';
    }
  }

}

